import { MagicConfigMixin, configQuery, SessionChange } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { notificationService, NotificationDelay } from '@gig/magic-messaging';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let RgLimitsPrompterComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.interval = null;
    this.enabledCountries = [];
    this.notificationTimeout = null;
    this.returning = true;
  }
  created() {
    configQuery("limits.rgLimitsNotificationInterval", (interval) => {
      this.interval = interval != null ? interval : null;
    });
    configQuery("limits.rgLimitsNotificationEnabledCountries", (enabledCountries) => {
      this.enabledCountries = enabledCountries != null ? enabledCountries : [];
    });
  }
  render() {
    return null;
  }
  sessionChange(isLoggedIn) {
    if (!isLoggedIn) {
      this.returning = false;
      this.end();
      return;
    }
    const user = magic.session.getUser();
    if (!this.enabledCountries.includes(user.country)) {
      return;
    }
    if (!this.returning) {
      this.showNotification();
    }
    this.start();
  }
  start() {
    if (this.notificationTimeout) {
      return;
    }
    const user = magic.session.getUser();
    if (!user) {
      return;
    }
    const lastVisit = new Date(user.lastVisit);
    const secondsSince = (new Date().getTime() - lastVisit.getTime()) / 1e3;
    const firstTimeout = (this.interval - secondsSince % this.interval) * 1e3;
    this.startInterval(firstTimeout);
  }
  end() {
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
      this.notificationTimeout = null;
    }
  }
  startInterval(timeout = this.interval * 1e3) {
    this.notificationTimeout = setTimeout(() => {
      this.showNotification();
      this.startInterval();
    }, timeout);
  }
  showNotification() {
    notificationService.show(this.$t("rg-limit-notification.text"), {
      closeDelay: NotificationDelay.LONG,
      uniqueID: "rg-limit-notification-text"
    });
  }
  destroyed() {
    this.end();
  }
};
__decorateClass([
  SessionChange({ immediate: true })
], RgLimitsPrompterComponent.prototype, "sessionChange", 1);
RgLimitsPrompterComponent = __decorateClass([
  Component({
    name: "rg-limits-prompter"
  })
], RgLimitsPrompterComponent);

export default RgLimitsPrompterComponent;
